<template lang="html">
  <div class="patrimonial-form">
		<form class="form-ui landscape-patrimonial-ui" novalidate>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label three" :class="{error: errors.has('revenu d\'activité')}">
					<label for="prénom">Revenu(s)</label>
					<input v-validate="'required'" type="text" name="revenu d'activité" v-model="directIncome.val">
					<custom-select :items="currencies" :selected="directIncome.cur" @change="directIncome.cur = $event" />
				</div>
				<div class="error-message">{{ errors.first('revenu d\'activité')}}</div>
			</div>
			<div class="form-elem-container row">
				<div class="ctn-input ctn-label three" :class="{error: errors.has('pensions et rentes')}">
					<label for="pensions et rentes">Pensions et rentes</label>
					<input v-validate="'required'" type="text" name="pensions et rentes" v-model="secondIncome.val">
					<custom-select :items="currencies" :selected="secondIncome.cur" @change="secondIncome.cur = $event" />
				</div>
				<div class="error-message">{{ errors.first('pensions et rentes')}}</div>
			</div>
		</form>
  </div>
</template>

<script>
import CustomSelect from '@/common/components/Form/CustomSelect'
import Currency from '@/common/components/MyPatrimonialLandscape/data/Currency'
import { mapGetters } from 'vuex'

export default {
	name: 'AnnualRecipe',
	components: {
		CustomSelect
	},
	data () {
		return {
			directIncome: { val: null, cur: 'EUR' },
			secondIncome: { val: null, cur: 'EUR' },
			currencies: Currency
		}
	},
	mounted () {
		this.directIncome.val = (this.estate.directIncome.val !== null) ? this.estate.directIncome.val : null
		this.directIncome.cur = (this.estate.directIncome.cur !== null) ? this.estate.directIncome.cur : null
		this.secondIncome.val = (this.estate.secondIncome.val !== null) ? this.estate.secondIncome.val : null
		this.secondIncome.cur = (this.estate.secondIncome.cur !== null) ? this.estate.secondIncome.cur : null
	},
	methods: {
		validate () {
			return this.$validator.validate()
		},
		save () {
			return new Promise((resolve, reject) => {
				this.validate().then((validation) => {
					if (validation) {
						this.$store.dispatch('storePatrimonial', {
							name: 'ANNUAL_RECIPE',
							data: {
								directIncome: this.directIncome,
								secondIncome: this.secondIncome
							},
							fromStart: false
						}).then((result) => {
							resolve(true)
						})
					}
				})
			})
		}
	},
	beforeDestroy () {
		this.save()
	},
	computed: {
		...mapGetters({
			estate: 'estate'
		})
	}
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// AnnualRecipe.vue?dbf465e2